module.exports = __webpack_public_path__ + "static/media/mobile_capy_page_area02_img_en@2x.3008d9f2.png";